import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  const rows = [{
    bad: 'Tu plata se va sin saber a dónde',
    good: 'Diagnóstico claro de cada peso'
  }, {
    bad: 'Ahorro que depende de tu voluntad',
    good: 'Sistema automático de 3 cuentas'
  }, {
    bad: 'Miedo a invertir el primer peso',
    good: 'Checklist paso a paso sin errores'
  }, {
    bad: 'La inflación se come tus ahorros',
    good: 'Escudo anti-inflación activo'
  }, {
    bad: 'Dependés de un solo sueldo',
    good: 'Plan de segundo ingreso real'
  }];
  return <section className="bg-white text-navy py-16 px-4" data-id="element-48">
      <div className="max-w-[720px] mx-auto" data-id="element-49">
        <h2 className="text-xl md:text-2xl font-bold text-center mb-8 leading-tight" data-id="element-50">
          Sin El Costo de No Hacer Nada <br className="hidden md:block" data-id="element-51" />
          <span className="text-navy/40 mx-2" data-id="element-52">vs.</span>{' '}
          <br className="md:hidden" data-id="element-53" />
          Con El Costo de No Hacer Nada
        </h2>

        <div className="flex flex-col gap-3" data-id="element-54">
          {rows.map((row, index) => <div key={index} className="flex flex-col md:flex-row border border-navy/10 rounded-xl overflow-hidden" data-id="element-55">
              <div className="flex-1 bg-light p-4 flex items-center gap-3 border-b md:border-b-0 md:border-r border-navy/10" data-id="element-56">
                <X className="text-red-500 flex-shrink-0" size={20} data-id="element-57" />
                <span className="text-[14px] text-navy/80" data-id="element-58">{row.bad}</span>
              </div>
              <div className="flex-1 bg-emerald/10 p-4 flex items-center gap-3" data-id="element-59">
                <Check className="text-emerald flex-shrink-0" size={20} data-id="element-60" />
                <span className="text-[14px] font-medium text-navy" data-id="element-61">
                  {row.good}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}